<template>
  <div id="home">

    <div class="div" v-loading="form_loading">
      <div class="title">
        Review Request
      </div>
      <div class="form">
        <div class="divt">
          Name
          <div class="margin-top-switch name" style="color: #2D3648;font-weight: normal;">{{name}}</div>
        </div>
        <div class="divt">
          QR
          <div class="qr_class margin-top-switch">
            <img :src="img_src"/>
          </div>
        </div>
        <div class="divt">
          Send
          <div class="margin-top-switch">
            <el-checkbox disabled v-model="is_need_email">E-Mail</el-checkbox>
          </div>
          <el-input v-if="is_need_email" class="margin-top-switch" placeholder="E-Mail" v-model="email"/>
        </div>
        <div class="divt">
          <div>
            <el-checkbox v-model="is_need_sms">Phone Number</el-checkbox>
          </div>
          <el-input v-if="is_need_sms" class="margin-top-switch" placeholder="Phone Number"
          v-model="phone_show" @change="change_phone">
            <template slot="prepend">
              <el-select v-model="countryCity" style="width:75px;" @change="change_phone">
                <el-option label="+1" value="+1"></el-option>
                <!-- <el-option label="+33" value="+33"></el-option> -->
                <el-option label="+44" value="+44"></el-option>
                <!-- <el-option label="+49" value="+49"></el-option>
                <el-option label="+55" value="+55"></el-option>
                <el-option label="+61" value="+61"></el-option>
                <el-option label="+81" value="+81"></el-option>
                <el-option label="+91" value="+91"></el-option> -->
              </el-select>
            </template>
          </el-input>
        </div>

      </div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <span class="btn" style="margin-right: 10px;background-color: #ffffff;color:#5856D6;border: 1px #5856D6 solid;" @click="go_list">Previous</span>
        <span class="btn" style="margin-right: 10px;background-color: #ffffff;color:#5856D6;border: 1px #5856D6 solid;" @click="go_edit">Edit</span>
        <span class="btn" @click="save">Request</span>
      </div>
    </div>
    <select-staffs ref="selectStaffsModel" @ok="selectedEmployee"></select-staffs>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi,postActionApi,postSetHeaderFileApi,postSetHeaderActionApi } from '@/network/manageApi';
  import moment from 'moment/moment';
  import SelectStaffs from './aiBusiness/SelectStaffs'
  export default {
    name: 'CreateAiBusinessPromoter',
    components: {
      SelectStaffs
    },
    data() {
      return {
        tags: [],
        ai_object: {user_name: "", staff_comment: ""},
        uuid: "",
        name: "",
        email: "",
        is_need_email: false,
        is_need_sms:false,
        countryCity: "+1",
        phone_show: "",
        img_src: null,
        form_loading: false
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
      this.is_need_email = false
      this.is_need_sms = false
      this.uuid = this.$route.params.uuid
      if(this.uuid) {
        this.form_loading = true
        getActionApi('/review/business-promoter/ai-generate/details?review_generator_uuid=' + this.uuid).then(res => {
          this.name = res.data.reviewer_name
        })
        this.img_src = null
        let param = {review_generator_uuid: this.$route.params.uuid}
        postSetHeaderFileApi('/review/business-promoter/ai-generate/create-qr', param, {"Content-Type":"application/json"}).then(res => {
          const blob = new Blob([res], { type: "image/*" })
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = () => {
            this.form_loading = false
            this.img_src = reader.result
          }
        })
      } else {
        this.$router.push({path:'/home'})
        return;
      }
    },
    methods:{
      go_list() {
        this.$router.push({path:'/aiBusinessPromoter'})
      },
      go_edit() {
        this.$router.push({path:'/aiBusinessPromoter/edit/' + this.uuid})
      },
      get_phone_require_length(type) {
        if(type == "+55") {
          return 11;
        } else if(type == "+33") {
          return 9;
        } else if(type == "+49") {
          return 11;
        } else if(type == "+81") {
          return 11;
        } else if(type == "+61") {
          return 10;
        } else if(type == "+91") {
          return 10;
        } else if(type == "+44") {
          return 9;
        } else if(type == "+1") {
          return 10;
        } else {
          return 0
        }
      },
      format_phone(localNumber, countryCode) {
        const phoneFormats = {
          "+1": "(XXX) XXX-XXXX", // USA, Canada
          "+44": "07XXX XXXXXX",   // UK Local Mobile
          "+91": "XXXXX-XXXXX",   // India
          "+61": "XXXX XXX XXX",  // Australia
          "+81": "XXX-XXXX-XXXX", // Japan
          "+49": "XXXX XXXXXXX",  // Germany
          "+33": "X XX XX XX XX",  // France
          "+55": "(XX) XXXXX-XXXX" // Brazil
        };
        let format = phoneFormats[countryCode] || "XXXX-XXXX-XXXX";
        let digits = localNumber.replace(/\D/g, "");
        let formattedNumber = "";
        let digitIndex = 0;
        for (let char of format) {
            if (char === "X" && digitIndex < digits.length) {
                formattedNumber += digits[digitIndex];
                digitIndex++;
            } else {
                formattedNumber += char;
            }
        }
        return formattedNumber;
      },
      change_phone() {
        if(!this.phone_show) {
          return;
        }
        let phone = this.phone_show.replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace(/[^0-9]/g, '')
        if(this.countryCity == "+44") {
          if(phone.length == 11 && phone.indexOf("07") == 0) {
            phone = phone.substring(2);
          } else if(phone.length == 10 && phone.indexOf("7") == 0) {
            phone = phone.substring(1);
          }
        }
        if(this.get_phone_require_length(this.countryCity) != phone.length) {
          this.$message({
            message: 'Please enter the correct phone number.',
            type: 'warning'
          });
          return;
        }
        this.phone_show = this.format_phone(phone, this.countryCity)
      },
      select_show() {
        this.$refs.selectStaffsModel.init()
      },
      selectedEmployee(list) {
        const map = this.tags.reduce((acc, item) => {
          acc[item.staff_uuid] = item;
          return acc;
        }, {});
        for(let item of list) {
          if(!map[item.review_employee_uuid]) {
            let obj = {name: item.employee_name, staff_uuid: item.review_employee_uuid}
            this.tags.push(obj);
          }
        }
      },
      closeTag(index) {
        this.tags.splice(index, 1);
      },
      moment,
      save() {
        if(!this.is_need_email && !this.is_need_sms) {
          this.$message({
            message: 'Please select at least one sending method.',
            type: 'warning'
          });
          return;
        }
        let param = {review_generator_uuid: this.uuid}
        if(this.is_need_email) {
          if(!this.email) {
            this.$message({
              message: 'Please enter your e-mail.',
              type: 'warning'
            });
            return;
          }
          if(!this.validateEmail(this.email)) {
            this.$message({
              message: 'Please enter the correct e-mail.',
              type: 'warning'
            });
            return;
          }
          param.email = this.email
        }
        if(this.is_need_sms) {
          if(!this.phone_show) {
            this.$message({
              message: 'Please enter your phone number.',
              type: 'warning'
            });
            return;
          }
          let phone = this.phone_show.replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace(/[^0-9]/g, '')
          if(this.countryCity == "+44") {
            if(phone.length == 11 && phone.indexOf("07") == 0) {
              phone = phone.substring(2);
            } else if(phone.length == 10 && phone.indexOf("7") == 0) {
              phone = phone.substring(1);
            }
          }
          if(this.get_phone_require_length(this.countryCity) != phone.length) {
            this.$message({
              message: 'Please enter the correct phone number.',
              type: 'warning'
            });
            return;
          }
          param.phone_number = this.get_phone_submit_format(this.countryCity, this.phone_show)
        }
        this.form_loading = true
        postActionApi("/review/business-promoter/ai-generate/send", param).then((res) => {
          if(res.code == 201 || res.code == 200) {
            const skipped = [res.data.email_msg, res.data.sms_msg].filter(Boolean)
            if(skipped.length) {
              this.$message.warning({message: "Sent, except: " + skipped.join(" ")});
            } else {
              this.$message.success({message: "Send Success"});
            }
            this.email = ""
            this.phone_show = ""
          }
        }).catch((err) => {
          this.$message.error({message: err.response.data.details.data.message});
        }).finally((res) => {
          this.form_loading = false
        })
      },
      get_phone_submit_format(countryCity, phone_show) {
        let phone = phone_show.replaceAll("-", "").replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "").replace(/[^0-9]/g, '')
        if(countryCity == "+1") {
          return countryCity + "-" + phone_show.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "-")
        } else if(countryCity == "+44") {
          return countryCity + "-" + phone_show.replaceAll(" ", "-")
        } else {
          return null;
        }
      },
      validateEmail(email) {
          var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
          return emailRegex.test(email);
      },
      validatePhoneNumber(phoneNumber) {
        var regex = /^(\+\d+-)?\d+-\d+-\d+$/;
        return regex.test(phoneNumber);
      },
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  .div{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .title{color:#2D3648;font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
  .label{display: flex;align-items: center;justify-content: center;}
  .label .no{background-color: #FED7D7;color: #822727;width: 28px;height: 20px;font-size: 12px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 5px;}
  .label .yes{background-color: #b3edff;color: #0075cb;width: 28px;height: 20px;font-size: 12px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 5px;}
  .pager{display: flex;justify-content: center;}
  .btn{height:30px;width:86px;cursor: pointer;background-color: #5856D6;color:#ffffff;border-radius: 6px;font-size: 14px;display: flex;align-items: center;justify-content: center;}
  .form{display: flex;flex-direction: column;width: 500px;background-color: #F8F9FA;margin: auto;padding: 15px 25px;border-radius: 10px;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .divt{display: flex;flex-direction: column;color:#2D3748;font-weight: bold;padding-bottom:20px;}
  .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .qr_class {display: flex;justify-content: center;align-items: center;}
  .qr_class img {width: 200px;}
  .margin-top-switch {margin-top: 20px;}

  .comments {width: 50%;}
  @media (max-width: 768px) {
    .title{flex-direction: column;display: none;}
    .div{padding:20px 5px;}
    .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
    .margin-top-switch {margin-top: 20px;}
    .comments {width: 98%;}
    .name {width: 98%;}
    .form{display: flex;flex-direction: column;width: 98%;background-color: #ffffff;margin: auto;}
    .qr_class {display: flex;justify-content: center;align-items: center;}
    .qr_class img {width: 60%;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
  .font-size-16 {font-size: 20px;}



</style>
